import PropTypes from 'prop-types';

import { useDispatch } from 'react-redux';

import { FaGift } from 'react-icons/fa';

import { openModal } from '../../features/modalSlice';

import { WIDGET_STATS_SETTINGS } from '../../config';
import { makeStatsRequestThrottled } from '../../lib';

import './OffersButton.css';

const OffersButton = ({ offers, isOpen }) => {
    const dispatch = useDispatch();

    if (
        offers?.quantity &&
        offers?.quantity !== '0' &&
        offers?.offersList?.length > 0 &&
        offers?.showOffersBtn &&
        isOpen
    ) {
        return (
            <div className="ab-offers">
                <button
                    onClick={() =>
                        dispatch(openModal({ modalId: 'OffersModal' }))
                    }
                >
                    <FaGift /> {offers?.text}
                </button>
                {offers?.quantity && (
                    <span className="ab-badge">{offers.quantity}</span>
                )}
            </div>
        );
    } else if (offers?.url && offers?.showOffersBtn && isOpen) {
        return (
            <div className="ab-offers">
                <a
                    href={offers?.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={() =>
                        makeStatsRequestThrottled(
                            WIDGET_STATS_SETTINGS.actions.offersClick
                        )
                    }
                >
                    <FaGift /> {offers?.text}
                </a>
                {offers?.quantity && (
                    <span className="ab-badge">{offers.quantity}</span>
                )}
            </div>
        );
    } else if (offers?.offersList?.length > 0 && !offers?.showOffersBtn) {
        return (
            <div
                className={`ab-offers  ab-offers-position-${offers?.offersPosition}`}
            >
                <button
                    onClick={() =>
                        dispatch(openModal({ modalId: 'OffersModal' }))
                    }
                >
                    <FaGift /> {offers?.text}
                </button>
                {offers?.quantity && (
                    <span className="ab-badge">{offers.quantity}</span>
                )}
            </div>
        );
    }

    return null;
};

OffersButton.propTypes = {
    offers: PropTypes.object,
    isOpen: PropTypes.bool,
};

export default OffersButton;
